export default {
      id: "ai-disabled-usage",
      viewBox: "0 0 36 36",
      url: __webpack_public_path__ + "sprite-46b249.svg#ai-disabled-usage",
      toString: function () {
        return this.url;
      }
    }